(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["luvixy-purchase-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luvixy-purchase-options')) {
    customElements.define('luvixy-purchase-options', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('[data-section]');
        this.form = this.section ? this.section.querySelector('form[action*="/cart/add"]') : null;
        this.variantInput = this.form ? this.form.querySelector('[name="id"]') : null;
        this.planInput = this.form ? this.form.querySelector('[data-luvixy-selling-plan-input]') : null;
        this.options = Array.from(this.querySelectorAll('[data-luvixy-option]'));
        this.cards = Array.from(this.querySelectorAll('[data-luvixy-option-card]'));
        this.planSelect = this.querySelector('[data-luvixy-plan-select]');
        this.data = [];

        try {
          this.data = JSON.parse(this.querySelector('[data-luvixy-purchase-options-data]').textContent);
        } catch (error) {
          this.data = [];
        }

        this.addEventListener('click', (event) => {
          const card = event.target.closest('[data-luvixy-option-card]');
          if (!card || event.target.matches('select, option, input')) return;
          const radio = card.querySelector('[data-luvixy-option]');
          if (radio && !radio.disabled) {
            radio.checked = true;
            this.sync();
          }
        });

        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-luvixy-option], [data-luvixy-plan-select]')) this.sync();
        });

        if (this.section) {
          this.section.addEventListener('change', () => {
            window.setTimeout(() => this.sync(), 0);
          });
        }

        document.addEventListener('variant:change', () => this.sync());
        this.sync();
      }

      sync() {
        if (!this.variantInput) return;

        const variant = this.data.find((item) => String(item.id) === String(this.variantInput.value));
        if (!variant) return;

        const allocations = variant.allocations || [];
        const selectedPlanId = this.planSelect ? this.planSelect.value : '';
        let allocation = allocations.find((item) => String(item.planId) === String(selectedPlanId));
        if (!allocation) allocation = allocations[0] || null;

        const oneTimePrice = this.querySelector('[data-luvixy-one-time-price]');
        const oneTimeCompare = this.querySelector('[data-luvixy-one-time-compare]');
        const subscriptionPrice = this.querySelector('[data-luvixy-subscription-price]');
        const subscriptionCompare = this.querySelector('[data-luvixy-subscription-compare]');
        const unavailable = this.querySelector('[data-luvixy-subscription-unavailable]');
        const delivery = this.querySelector('.luvixy-purchase-options__delivery');
        const subscriptionRadio = this.querySelector('[data-luvixy-option][value="subscription"]');
        const oneTimeRadio = this.querySelector('[data-luvixy-option][value="one_time"]');

        if (oneTimePrice) oneTimePrice.textContent = variant.price;
        this.updateCompare(oneTimeCompare, variant.compareAt);

        if (this.planSelect) {
          const currentValue = allocation ? String(allocation.planId) : '';
          this.planSelect.innerHTML = '';
          allocations.forEach((item) => {
            const option = document.createElement('option');
            option.value = item.planId;
            option.textContent = item.label;
            option.selected = String(item.planId) === currentValue;
            this.planSelect.append(option);
          });
          this.planSelect.disabled = !allocation;
        }

        if (subscriptionRadio) subscriptionRadio.disabled = !allocation;
        if (delivery) delivery.hidden = !allocation;

        if (allocation) {
          if (subscriptionPrice) subscriptionPrice.textContent = allocation.price;
          this.updateCompare(subscriptionCompare, allocation.compareAt);
          if (unavailable) unavailable.hidden = true;
        } else {
          if (subscriptionPrice) subscriptionPrice.textContent = '—';
          this.updateCompare(subscriptionCompare, null);
          if (unavailable) unavailable.hidden = false;
          if (subscriptionRadio && subscriptionRadio.checked && oneTimeRadio) oneTimeRadio.checked = true;
        }

        const selected = this.querySelector('[data-luvixy-option]:checked');
        const isSubscription = Boolean(selected && selected.value === 'subscription' && allocation);

        this.cards.forEach((card) => {
          card.classList.toggle('is-selected', card.dataset.luvixyOptionCard === (isSubscription ? 'subscription' : 'one_time'));
          if (card.dataset.luvixyOptionCard === 'subscription') card.classList.toggle('is-disabled', !allocation);
        });

        if (this.planInput) {
          this.planInput.value = isSubscription ? allocation.planId : '';
          this.planInput.disabled = !isSubscription;
        }
      }

      updateCompare(element, value) {
        if (!element) return;
        element.hidden = !value;
        element.textContent = value || '';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
